@if (quizStatus() !== 'disabled') {
  <div class="quiz-card" [class.quiz-card--excluded]="quizExcluded()" [class.quiz-card--pending-review]="isPendingReview()">
    @if (isBulkGenerating()) {
      <div class="quiz-card__bulk-overlay"></div>
    }

    <!-- Header -->
    <div class="quiz-card__header" [class.quiz-card__header--static]="isNonExpandableState()" (click)="toggleCard()">
      <div class="quiz-card__header-left">
        <app-enfaf-icon [svgIconName]="isPendingReview() ? 'check-circle-warning' : 'check-circle'" iconSize="24px"></app-enfaf-icon>
        <div class="quiz-card__header-texts">
          <span class="quiz-card__title">Autoevaluación</span>
          @if (isPendingReview()) {
            <span class="quiz-card__subtitle quiz-card__subtitle--pending">Generado automáticamente - Pendiente de revisión</span>
          } @else if (quizStatus() === 'pending') {
            <span class="quiz-card__subtitle">Se crea automáticamente a partir de la transcripción del vídeo.</span>
          }
        </div>
      </div>
      <div class="quiz-card__header-right">
        @if (isPendingReview()) {
          <button
            class="quiz-cta quiz-cta--review"
            [disabled]="isMarkingReviewed() || quizStatus() === 'processing'"
            (click)="$event.stopPropagation(); markAsReviewed()"
          >
            @if (isMarkingReviewed()) {
              <mat-spinner diameter="14"></mat-spinner>
            } @else {
              <svg width="15" height="11" viewBox="0 0 15.3125 10.9375" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14.75 0.25c0.33 0.33 0.33 0.87 0 1.2l-9.33 9.33c-0.16 0.16-0.37 0.25-0.6 0.25s-0.44-0.09-0.6-0.25l-4-4c-0.33-0.33-0.33-0.87 0-1.2 0.33-0.33 0.87-0.33 1.2 0l3.4 3.4 8.73-8.73c0.33-0.33 0.87-0.33 1.2 0z"
                  fill="#16bd5b"
                  fill-rule="evenodd"
                />
              </svg>
            }
            Marcar como revisado
          </button>
        }
        @if (questions().length === 0 && quizStatus() !== 'error') {
          <button
            type="button"
            class="quiz-cta quiz-cta--generate"
            [disabled]="isBulkGenerating() || quizExcluded() || isGenerating() || !hasVideo()"
            (click)="$event.stopPropagation(); onGenerate()"
            [title]="!hasVideo() ? 'Se requiere un ID de Vimeo válido para generar la autoevaluación' : ''"
          >
            @if (isGenerating()) {
              <mat-spinner diameter="14"></mat-spinner>
            }
            Generar preguntas con IA
          </button>
        }
        @if (!isNonExpandableState() && !isPendingReview() && isCardExpanded()) {
          <svg class="quiz-card__chevron" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="m4 12 6-6 6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        } @else if (!isNonExpandableState() && !isPendingReview()) {
          <svg
            class="quiz-card__chevron quiz-card__chevron--down"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="m4 8 6 6 6-6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        }
      </div>
    </div>

    <!-- Body -->
    @if (!isNonExpandableState() && isCardExpanded()) {
      <div class="quiz-card__body">
        <!-- Loading -->
        @if (isLoading()) {
          <div class="quiz-card__spinner">
            <mat-spinner diameter="32"></mat-spinner>
          </div>
        } @else {
          <!-- Error state (quizStatus error, no questions) -->
          @if (quizStatus() === 'error' && questions().length === 0) {
            <div class="quiz-state quiz-state--error">
              <svg class="quiz-state__error-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.609 1.5h10.782l5.609 5.61v10.78L17.391 23.5H6.609L1 17.89V7.11L6.609 1.5Z"
                  fill="none"
                  stroke="#e03131"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                />
                <path d="m8.219 8.219 7.562 7.562M15.781 8.219l-7.562 7.562" stroke="#e03131" stroke-width="1.5" stroke-linecap="round" />
              </svg>
              <div class="quiz-state__texts">
                <span class="quiz-state__title">Se ha producido un error al generar la autoevaluación</span>
                <span class="quiz-state__subtitle">{{
                  quizErrorFriendly() || 'Inténtalo de nuevo. Si el problema persiste, revisa la transcripción del vídeo.'
                }}</span>
              </div>
              <button
                class="quiz-cta quiz-cta--generate"
                [disabled]="isGenerating() || !hasVideo()"
                (click)="$event.stopPropagation(); onGenerate()"
                [title]="!hasVideo() ? 'Se requiere un ID de Vimeo válido para generar la autoevaluación' : ''"
              >
                @if (isGenerating()) {
                  <mat-spinner diameter="14"></mat-spinner>
                }
                Reintentar
              </button>
            </div>
          }

          <!-- Generic error message (loading error, etc.) -->
          @if (errorMessage() && quizStatus() !== 'error') {
            <div class="quiz-card__error">
              <mat-icon>error_outline</mat-icon>
              <span>{{ errorMessage() }}</span>
            </div>
          }

          <!-- Generating state (first generation, no existing questions) -->
          @if (isGenerating() && questions().length === 0) {
            <div class="quiz-state quiz-state--generating">
              <mat-spinner diameter="32"></mat-spinner>
              <div class="quiz-state__texts">
                <span class="quiz-state__title">Generando autoevaluación...</span>
                <span class="quiz-state__subtitle">Analizando la transcripción del vídeo. Esto puede tardar unos segundos.</span>
              </div>
            </div>
          }

          <!-- Regenerating state (has existing questions) -->
          @if (isGenerating() && questions().length > 0) {
            <div class="quiz-state quiz-state--generating">
              <mat-spinner diameter="28"></mat-spinner>
              <div class="quiz-state__texts">
                <span class="quiz-state__title">Regenerando autoevaluación...</span>
                <span class="quiz-state__subtitle">Se reemplazarán las preguntas actuales con nuevas preguntas generadas por IA.</span>
              </div>
            </div>
          }

          <!-- AI info banner -->
          @if (questions().length > 0 && !isGenerating() && quizStatus() !== 'processing') {
            <div class="quiz-card__ai-banner">
              <app-enfaf-icon svgIconName="info" iconSize="20px"></app-enfaf-icon>
              <span><b>Nota:</b> Esta autoevaluación ha sido generado por Inteligencia Artificial como apoyo al estudio.</span>
            </div>
          }

          <!-- Questions list (read mode) -->
          @if (questions().length > 0 && !isEditing() && !isGenerating()) {
            <div class="quiz-card__questions">
              @for (question of questions(); track question.quizQuestionId; let i = $index; let last = $last) {
                <div class="quiz-card__question">
                  <div class="quiz-card__question-header">
                    <span class="quiz-card__question-label">Pregunta {{ i + 1 }}</span>
                  </div>
                  <ol class="quiz-card__question-list" start="{{ i + 1 }}">
                    <li class="quiz-card__question-statement">{{ question.statement }} {{ question.isRequired ? '*' : '' }}</li>
                  </ol>
                  <div class="quiz-card__options">
                    @for (option of question.options; track option; let j = $index) {
                      <div class="quiz-card__option">
                        <span class="quiz-card__option-text">{{ optionLabel(j) }}. {{ option }}</span>
                        @if (question.correctOptionIndex === j) {
                          <span class="quiz-card__option-badge">Correcta</span>
                        }
                      </div>
                    }
                  </div>
                </div>
                @if (!last) {
                  <hr class="quiz-card__question-divider" />
                }
              }
            </div>
          }

          <!-- Questions list (edit mode) -->
          @if (isEditing()) {
            <div class="quiz-card__questions">
              @for (group of questionsForm.controls; track group.getRawValue().quizQuestionId; let i = $index; let last = $last) {
                <div class="quiz-card__question">
                  <div class="quiz-card__question-header">
                    <span class="quiz-card__question-label">Pregunta {{ i + 1 }}</span>
                    <app-enfaf-icon
                      svgIconName="trash-red"
                      iconSize="21px"
                      [isButton]="true"
                      (onClick)="$event.stopPropagation(); deleteEditQuestion(i)"
                    ></app-enfaf-icon>
                  </div>
                  <div class="quiz-card__form">
                    <enfaf-input
                      variant="primary"
                      label="Redacta la pregunta"
                      [control]="group.controls.statement"
                      errorLabel="Este campo es requerido"
                    ></enfaf-input>

                    <enfaf-input
                      variant="primary"
                      label="¿Qué respuestas hay? Separadas por punto y coma"
                      [control]="group.controls.optionsText"
                      errorLabel="Se requieren dos respuestas"
                      (keydown.enter)="onOptionsEnter($event, group)"
                    ></enfaf-input>
                    @if (parsedOptions(group).length >= 2) {
                      <div class="quiz-card__correct-section">
                        <span class="quiz-card__correct-label">¿Cuál es la respuesta correcta?*</span>
                        <div class="quiz-card__correct-options">
                          <mat-radio-group [formControl]="group.controls.correctOptionIndex" class="quiz-card__correct-radio-group">
                            @for (option of parsedOptions(group); track option; let j = $index) {
                              <div class="quiz-card__correct-option-row">
                                <div
                                  ><mat-radio-button [value]="j" class="quiz-card__radio-btn">{{ option }}</mat-radio-button></div
                                >
                              </div>
                            }
                          </mat-radio-group>
                        </div>
                      </div>
                    }

                    <!-- isRequired checkbox -->
                    <div class="quiz-card__is-required">
                      <app-enfaf-checkbox [control]="group.controls.isRequired">
                        <span [ngStyle]="{ 'font-size': '16px' }">Mostrar pregunta</span>
                      </app-enfaf-checkbox>
                    </div>
                  </div>
                </div>
                @if (!last) {
                  <hr class="quiz-card__question-divider" />
                }
              }
              <!-- Actions -->
              @if (!isGenerating()) {
                <div class="quiz-card__actions">
                  <app-enfaf-button
                    [setNgStyle]="{ 'background-color': 'white' }"
                    type="modal-outline"
                    [disabled]="isSaving()"
                    (click)="onCancelEdit()"
                    >Cancelar</app-enfaf-button
                  >
                  <app-enfaf-button [disabled]="isSaving() || hasFormValidationErrors()" (onClick)="onSave()">
                    @if (isSaving()) {
                      <mat-spinner diameter="14"></mat-spinner>
                    } @else {
                      Guardar
                    }
                  </app-enfaf-button>
                </div>
              }
            </div>
          }

          @if (!isGenerating() && quizStatus() !== 'processing' && questions().length > 0 && !isEditing()) {
            <div class="quiz-card__row">
              <app-enfaf-switch-dark
                [control]="visibleControl"
                label="Mostrar autoevaluación"
                [disabled]="isSaving() || isDeleting()"
                (onChange)="onToggleVisible($event)"
              ></app-enfaf-switch-dark>

              <div class="quiz-card__secondary-actions">
                <button class="quiz-cta quiz-cta--edit" [disabled]="isSaving() || isDeleting()" (click)="$event.stopPropagation(); onStartEdit()">
                  <app-enfaf-icon svgIconName="border-edit-white" iconSize="16px"></app-enfaf-icon>
                  Editar
                </button>

                <button
                  class="quiz-cta"
                  [disabled]="isGenerating() || !hasVideo() || isSaving() || isDeleting()"
                  (click)="$event.stopPropagation(); onGenerate()"
                  [title]="!hasVideo() ? 'Se requiere un ID de Vimeo válido para generar la autoevaluación' : ''"
                >
                  Regenerar
                </button>

                <button
                  class="quiz-cta quiz-cta--danger"
                  [disabled]="isDeleting() || isSaving()"
                  (click)="$event.stopPropagation(); confirmDeleteQuiz()"
                >
                  @if (isDeleting()) {
                    <mat-spinner diameter="14"></mat-spinner>
                  } @else {
                    Eliminar
                  }
                </button>
              </div>
            </div>
          }
        }
      </div>
    }
  </div>
}
